import { Link } from 'react-router-dom'
import maharajPortrait from '../../../assets/images/rajumoharaj.png'

const MANDALA_DOTS = [
  { cx: 100, cy: 10 },
  { cx: 184, cy: 70 },
  { cx: 16, cy: 130 },
  { cx: 150, cy: 168 },
  { cx: 50, cy: 32 },
  { cx: 186, cy: 118 },
  { cx: 14, cy: 82 },
]

export default function ConsultationsHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-primary pt-28 pb-16 lg:pt-32">
      <div aria-hidden="true" className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-linear-to-b from-[#3a0a14] via-primary to-[#2a0710]" />
        <div className="absolute inset-0 bg-[radial-linear(55%_60%_at_50%_12%,rgba(232,119,15,0.20),transparent_70%)]" />
        <div className="absolute inset-0 bg-[radial-linear(45%_55%_at_100%_100%,rgba(232,119,15,0.10),transparent_70%)]" />

        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-136 h-136 md:w-216 md:h-216 opacity-[0.15] animate-[spin_120s_linear_infinite] motion-reduce:animate-none flex items-center justify-center">
          <span className="text-[150px] md:text-[250px] text-[#E6C878] filter drop-shadow-[0_0_15px_rgba(230,200,120,0.5)] select-none">ॐ</span>
        </div>

        <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2xl h-138 md:w-248 md:h-248 opacity-[0.16] animate-[spin_280s_linear_infinite_reverse] motion-reduce:animate-none" viewBox="0 0 200 200" fill="none" stroke="#E6C878">
          <circle cx="100" cy="100" r="94" strokeWidth="0.4" />
          <circle cx="100" cy="100" r="10" strokeWidth="0.8" />
          <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(0 100 100)" />
          <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(60 100 100)" />
          <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(120 100 100)" />
          {MANDALA_DOTS.map((dot) => (
            <circle key={`${dot.cx}-${dot.cy}`} cx={dot.cx} cy={dot.cy} r="2.4" fill="#E6C878" stroke="none" fillOpacity="0.7" />
          ))}
        </svg>
        <div className="absolute inset-0 bg-linear-to-r from-primary/85 via-primary/45 to-transparent" />
        <div className="absolute inset-0 bg-linear-to-t from-primary via-primary/20 to-transparent" />
      </div>

      <div className="container relative z-10 px-6 mx-auto">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.05fr] items-center">
          <div className="relative">
            <div className="relative overflow-hidden rounded-4xl border border-white/10 shadow-2xl shadow-black/40">
              <img src={maharajPortrait} alt="Astro Raju Maharaj Ji consultation" className="w-full h-110 object-cover sm:h-160" />
              <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/10 to-transparent" />

              <div className="absolute top-5 left-5 hero-card-badge">
                <span className="text-secondary">✦</span> Premium Consultation
              </div>

              {/* Positioning lives on the wrapper: .hero-card-glass sets its own
                  `position: relative`, which would override an `absolute` utility
                  placed on the same element. */}
              <div className="absolute inset-x-5 bottom-5">
                <div className="hero-card-glass overflow-hidden rounded-3xl p-5">
                  <div className="grid grid-cols-2 divide-x divide-primary/10 relative z-10">
                    <div className="pr-4">
                      <p className="text-2xl font-cinzel font-semibold text-primary">4,800+</p>
                      <p className="mt-1 text-[9px] uppercase tracking-[0.3em] text-[#8B7355]">Verified clients</p>
                    </div>
                    <div className="pl-4">
                      <p className="text-2xl font-cinzel font-semibold text-primary">98%</p>
                      <p className="mt-1 text-[9px] uppercase tracking-[0.3em] text-[#8B7355]">Success rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8 text-white">
            <div className="hero-chip">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-secondary">
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
              </svg>
              <span className="uppercase tracking-[0.35em]">Master system</span>
            </div>
            <div className="space-y-4">
              <h1 className="text-3xl font-cinzel leading-tight font-semibold md:text-4xl lg:text-5xl">
                Astro Raju <span className="text-secondary">Maharaj Ji</span>
              </h1>
              <p className="text-sm leading-relaxed text-white/70 md:text-base max-w-xl">
                Experience the pinnacle of Vedic wisdom with direct, high-precision guidance designed to unlock your highest potential.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3 text-sm text-white/70">
                <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10 text-secondary">✤</span>
                <p>Exact timing insights for career, relationships, wealth and wellbeing.</p>
              </div>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10 text-secondary">✤</span>
                <p>Modern service design that feels luxurious, clear, and deeply authentic.</p>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div className="hero-stat-block">
                <p className="text-[10px] uppercase tracking-[0.35em] text-[#8B7355]">Years of mastery</p>
                <h4 className="mt-2 text-2xl font-semibold">15+</h4>
                <p className="mt-2 text-sm text-[#5C3A18]">Deep Vedic astrology experience</p>
              </div>
              <div className="hero-stat-block">
                <p className="text-[10px] uppercase tracking-[0.35em] text-[#8B7355]">Expert astrologers</p>
                <h4 className="mt-2 text-2xl font-semibold">5+</h4>
                <p className="mt-2 text-sm text-[#5C3A18]">Specialists available today</p>
              </div>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="/book-maharaj-ji" className="hero-btn-primary inline-flex items-center justify-center w-full sm:w-auto rounded-full px-8 py-3.5 text-sm font-semibold uppercase tracking-[0.25em]">
                Book master session
              </Link>
              <Link
                to="/maharaj-ji"
                className="hero-btn-secondary inline-flex items-center justify-center w-full sm:w-auto rounded-full px-8 py-3.5 text-sm font-semibold uppercase tracking-[0.25em]">
                Meet the Maharaj Ji
              </Link>
            </div>

            <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-5 py-4 text-sm text-white/70">
              <span className="relative inline-flex h-2.5 w-2.5 shrink-0">
                <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
              </span>
              <p>
                <span className="font-medium text-white">Live now —</span> elevated guidance for clients seeking a premium, trusted astrology experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
